import gql from 'graphql-tag';

export default () => gql`
  query {
    getConfigIncomingOutgoingRoute(dummy: "") {
      configIncomingOutgoingRouteList{
        value
        description
      }
    }
  }
`;
